import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "children", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Type } from '@uswitch/spark';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
export { default as LinkListItem } from './link-list-item';

var LinkList = function LinkList(_ref) {
  var title = _ref.title,
      children = _ref.children,
      variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsxs("nav", _objectSpread(_objectSpread({
    sx: {
      paddingTop: ['32px', '40px'],
      paddingBottom: ['16px', '24px'],
      paddingX: '16px',
      backgroundColor: 'grey-05'
    }
  }, rest), {}, {
    children: [_jsx(Type.H4, {
      as: 'header',
      sx: {
        color: 'secondary',
        textAlign: 'center'
      },
      children: title
    }), _jsx("ul", {
      sx: {
        listStyle: 'none',
        p: '0',
        m: '0',
        marginTop: '16px',
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
        justifyContent: 'center'
      },
      children: children
    })]
  }));
};

export default LinkList;
//# sourceMappingURL=link-list.js.map